<template>
  <div>
    <div v-if="obj1.length" v-for="(item, index) in obj1" class="objhtml">
      <div class="funMedicineBox6" v-for="(item1, index1) in item.dataList" :key="index1">
        <div>
          <Head :UserInfo="PagesInitDataA.UserInfo" :title2="title2"></Head>
          <div class="pages17_content">
            <div class="funMedicinesecod_line"></div>
            <div class="funMedicinesecod_line_a">
              <div class="pages17_content_top_title">
                <div class="pages17_content_top_title_t">{{ item1.FunctionName }}</div>
                <img style="width: 100%;"
                  src="https://image.giantgocloud.com/www/ImageMapping/image/20240113/801B472E85764831BFBBDFFDC59E036C.png"
                  alt="" />
              </div>
              <div class="pages17_content_top_title_q"  :style="{ color: item1.FunctionColor,borderColor:item1.FunctionColor,backgroundColor:hexToRgb(item1.FunctionColor,0.1)}">{{ item1.FunctionLevel }}</div>
            </div>

            <div class="pages17_content_top_content">{{ item1.FuncIntroduce }}</div>
            <div class="funMedicine6" v-for="(item2, index2) in item1.contentA" :key="index2"
              :id="'getDivHeight' +String(idIndex) +String(index) + String(index1) + String(index2)">
              <div class="funMedicine6_box">
                <div>
                  <div class="funMedicine6HeadTop">
                    <div>
                      <div class="funMedicine6Head">
                        <span>您的{{ item2.Name }}指标为：</span><span>{{ item2.Value
                        }}&nbsp;{{ item2.Unit }}</span>
                      </div>
                      <div class="process" style="margin-top: 30px;" id="processdata">
                        <div class="process1" v-for="(color, index3) in item2.ColorLengths" :key="index3"
                          :class="index3 == item2.ColorLengths.length - 1 ? 'process1_A' : ''" :style="{
                            width: `${(180 / item2.ColorLengths.length).toFixed(1) + 'px'}`,
                            background: `${color.ColorNum}`,
                          }">
                          <span>{{ color.ColorName }}</span>
                        </div>

                        <div class="Yuan" :style="{
                          border: `2px solid ${item2.RoundColor}`, top: `-5px`, left: `${((item2.ColorValuePercent / 100) * 180).toFixed(1) + 'px'}`
                        }">
                        </div>
                      </div>
                    </div>
                    <div>
                      <div class="funMedicine6Text">
                        {{ item2.CheckItemDetail }}
                      </div>
                      <div class="problem" v-for="(itemd, index3) in item2.text" :key="index3">
                        <div class="problemText">
                          {{ itemd }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Head from "./head.vue"
export default {
  props: ['PagesInitData','PagesInitDataA','idIndex'],
  data() {
    return {
      obj1: [],
      newlistDataA: {},
      title2:'健康分析',
      list: [],
      list3: [],
      list4: [],
      list5: [],
      list6: [],
      data: {},
      dan: {},
      num: 0,
      text: [],
      newList: [],
      iLength: 0,
      pageNum: 0,
      pageNum1: 0,
      pageNum2: 0,
      pagesQ: 0,
      pagesI: 0
    }
  },
  components: {
    Head,
  },
  watch: {
    PagesInitData: {
      deep: true, // 开启深度监听 专门对付复杂数据类型
      handler: function (newValueA, oldValue) {
        console.log(newValueA,'newValueA11111111111111')
       
      }
    }
  },
  mounted() {
    console.log('aaaaaaaaaaaaaa',)
    let that = this
    const id = this.$query('id')
    this.obj1 = [];
        for (let i = 0; i < this.PagesInitData.List.length; i++) {
          this.PagesInitData.List[i].dataList = []
        }
        this.obj1 = this.PagesInitData.List
        console.log('数据17', this.obj1)
        this.init();
  },
  methods: {
    hexToRgb(hex, opt) {
        // Remove "#" symbol from the beginning of the string
        hex = hex.replace("#", "");
        // Convert each pair of characters to decimal values for red, green, and blue
        var red = parseInt(hex[0] + hex[1], 16);
        var green = parseInt(hex[2] + hex[3], 16);
        var blue = parseInt(hex[4] + hex[5], 16);
        return 'rgba(' + red + ',' + green + ',' + blue + ',' + opt + ')';
      },
    init() {
      let that = this;
      if (that.pagesI < this.obj1.length) {
        let a = {
          FuncIntroduce: this.obj1[that.pagesI].FuncIntroduce,
          FunctionColor: this.obj1[that.pagesI].FunctionColor,
          FunctionLevel: this.obj1[that.pagesI].FunctionLevel,
          FunctionName: this.obj1[that.pagesI].FunctionName,
          ReportLineList: this.obj1[that.pagesI].ReportLineList,
          contentA: []
        }
        this.obj1[that.pagesI].dataList.push(a)
        console.log('this.obj1000', this.obj1)
        this.init1()
      }

    },
    init1() {
      let that = this;
      console.log('that.pagesQ', that.pagesQ)
      if (that.pagesQ < this.obj1[that.pagesI].ReportLineList.length) {
        console.log('this.obj1[that.pagesI].dataList.length - 1', this.obj1[that.pagesI].dataList.length - 1)
        this.obj1[that.pagesI].dataList[this.obj1[that.pagesI].dataList.length - 1].contentA.push(this.obj1[that
          .pagesI].ReportLineList[that.pagesQ]);
        console.log('010101010', this.obj1[that.pagesI].ReportLineList[that.pagesQ])
        console.log('this.obj1[that.pagesI].dataList', this.obj1[that.pagesI].dataList)
        that.pagesQ++
        setTimeout(() => {
          that.$forceUpdate()
          console.log('0000', 'getDivHeight' +String(that.idIndex)+ String(that.pageNum) + String(that
            .pageNum1) + String(that.pageNum2))
          let getDivHeightBox = document.getElementById('getDivHeight'+String(that.idIndex) + String(that.pageNum) + String(that
            .pageNum1) + String(that.pageNum2))
          console.log('getDivHeightBox.offsetLeft', getDivHeightBox.offsetLeft)
          // that.init1();
          if (getDivHeightBox.offsetLeft > 500) {
            this.obj1[that.pagesI].dataList[this.obj1[that.pagesI].dataList.length - 1].contentA.splice(-1, 1);
            that.$forceUpdate()
            console.log('this.obj1xxx', this.obj1)
            that.pageNum1++
            that.pageNum2 = 0;
            that.pagesQ--
            that.init()
          } else {
            that.pageNum2++
            console.log('that.pageNum1', that.pageNum1)
            console.log('that.pageNum2', that.pageNum2)
            that.init1();
          }
        }, 1)
      } else {
        that.pagesI++;
        that.pagesQ = 0;
        that.pageNum++
        that.pageNum1 = 0;
        that.pageNum2 = 0;
        that.init();
      }
    },
    // 函数自调用
    setnewdata() {
      let that = this


    }
  }
}
</script>

<style lang='scss' scoped>
.funMedicinesecod_line_a {
  display: flex;
  align-items: center;
  justify-content: center;
}

.funMedicinesecod_line {
  position: absolute;
  top: 0;
  margin: 40px 0;
}

.pages17_content_top_title_q {
  position: relative;
  left: -51px;
  width: 28px;
  top: -13px;
  height: 24px;
  background: #FAE8EA;
  border: 1px solid;
  border-radius: 7px;
  text-align: center;
  line-height: 24px;
  font-size: 20px;
}

.funMedicineBox6 {
  display: inline-block;
  position: relative;
  width: 595px;
  height: 841px;

  .pages17_content {
    padding-left: 51px;
    column-count: 2;
    column-fill: auto;
    justify-content: space-around;
    flex-wrap: wrap;
    height: 730px;
    padding-top: 50px;
    column-span: all;
  }

  // padding: 80px 60px 0 60px;

  .funMedicine6 {
    position: relative;
    // height: 841px;
    overflow: hidden;
    // padding: 0 0 0 30px;

    .funMedicine6_box {
      display: inline-block;
      width: 214px;
      position: relative;

      .process {
        position: relative;
        display: flex;
        // justify-content: center;
        text-align: center;
        margin-top: 30px;

        span {
          display: inline-block;
          transform: translateY(10px);
          margin-top: 5px;
        }

        .process1 {
          // width: 100px;
          height: 4px;
          background: #5ec692;
          opacity: 1;
        }

        .process1:nth-of-type(1) {
          height: 4px;
          background: #d51931;
          opacity: 1;
          border-radius: 50px 0px 0px 50px;
        }

        .process1:nth-last-of-type(1) {
          height: 4px;
          background: #e29a30;
          opacity: 1;
          border-radius: 0px 50px 50px 0px !important;
        }

        .process1_A {
          height: 4px;
          background: #e29a30;
          opacity: 1;
          border-radius: 0px 50px 50px 0px !important;
        }
      }

      // margin: 20px 0;
    }

    /* 设置两张图片的位置 */
    .funMedicine6HeadTop {
      // -webkit-column-break-inside: avoid;
      // margin-top: 10px;
    }

    .funMedicine6Head {
      margin-top: 5px;
      // margin-left: 44px;
      // width: 367px;
      height: 26px;
      font-size: 16px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #4e4e4e;
      line-height: 26px;

      // letter-spacing: 1px;
      span {
        color: #1386b0;
      }
    }


    .funMedicine6Footer {
      position: absolute;
      width: 40px;
      height: 40px;
      background: #1386b0;
      border-radius: 0px 0px 0px 0px;
      opacity: 1;
      right: 0px;
      bottom: -10px;
      // background: url("../../../assets/analysis/be9299d8ce7aecbcc66619a0dd3f403.png") no-repeat;
      background-size: contain;
      text-align: center;
      font-size: 13px;
      padding-left: 2px;
      box-sizing: border-box;
      font-family: DIN-Bold, DIN;
      font-weight: bold;
      color: #ffffff;
      line-height: 33px;
    }

    .funMedicine6Cloumns {
      // margin-top: 12px;
      // margin-left: 44px;
      width: 122px;
      height: 4px;
      background: linear-gradient(117deg, #1386B0 0%, rgba(19, 134, 176, 0) 100%);
      border-radius: 0px 0px 0px 0px;
      opacity: 1;
      // margin: 10px 0;
    }

    .funMedicine6Num {
      width: 57px;
      height: 20px;
      font-size: 12px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      color: #4e4e4e;
      line-height: 24px;
      margin-top: 20px;
      -webkit-background-clip: text;
    }


    .Yuan {
      position: absolute;
      display: inline-block;
      width: 14px;
      height: 14px;
      border-radius: 50%;
      background: white;
    }

    .processText {
      width: 528px;
      height: 26px;
      font-size: 14px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #4e4e4e;
      line-height: 26px;
      margin-top: 33px;
      margin-left: 44px;

      span {
        color: #1386b0;
      }
    }

    .funMedicine6Cloumn {
      display: inline-block;
      width: 4px;
      height: 30px;
      margin-right: 8px;
      margin-left: 45px;
      margin-top: 51px;
      vertical-align: middle;
      background: linear-gradient(117deg,
          #1386b0 0%,
          rgba(19, 134, 176, 0) 100%);
      border-radius: 0px 0px 0px 0px;
      opacity: 1;
    }

    .funMedicine6Text {

      margin-top: 46px;
      display: inline-block;
      width: 214px;
      // height: 30px;
      font-size: 9px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #474F57;
      // line-height: 30px;
      letter-spacing: 1px;
      // -webkit-background-clip: text;
      // vertical-align: middle;
    }

    .problem {
      width: 229px;
      // margin-left: 45px;
      font-size: 10px;
      // margin-top: 8px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      // line-height: 14px;

      .problemText {
        color: #4e4e4e;
        // padding: 10px 0;

        span {
          color: #1386b0;
          margin-right: 3px;
        }
      }
    }

    .problem:nth-child(1) {
      // margin-top: 24px;
    }

    .footers {
      margin-top: 12px;
      margin-left: 45px;
      color: #1386b0;
    }
  }
}

.pages17_content_top_title {
  position: relative;
  left: -51px;
  width: 237px;
  min-height: 44px;

  .pages17_content_top_title_t {
    position: absolute;
    left: 44px;
    top: -6px;
    font-size: 23px;
    font-weight: bold;
    color: #3A6DA5;
  }
}

.pages17_content_top_content {
  width: 214px;
  font-size: 10px;
  font-weight: 400;
  color: #474F57;
  margin-bottom: 26px;
}</style>
